import { render, staticRenderFns } from "./igG.vue?vue&type=template&id=7f2834a2&scoped=true"
import script from "./igG.vue?vue&type=script&lang=js"
export * from "./igG.vue?vue&type=script&lang=js"
import style0 from "./igG.vue?vue&type=style&index=0&id=7f2834a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2834a2",
  null
  
)

export default component.exports